module.exports = __webpack_public_path__ + "img/product-placeholder.1b995e45.png";